(function () {
  // Alleen draaien op collectiepagina's
  if (!/\/collections\//.test(location.pathname)) return;

  function enhanceAvailability(root) {
    // Verberg "Niet op voorraad"
    root.querySelectorAll('input[name="filter.v.availability"][value="0"]').forEach(function (input) {
      const holder = input.closest('.facets__item') || input.closest('label') || input.parentElement;
      if (holder) holder.style.display = 'none';
    });

    // Vervang "Op voorraad" door MUKI-toggle met vaste tekst
    root.querySelectorAll('input[name="filter.v.availability"][value="1"]').forEach(function (input) {
      if (input.dataset.mukiEnhanced === "1") return;

      const siblingLabel = (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') ? input.nextElementSibling : null;
      const parentLabel  = input.closest('label');
      const oldLabel     = siblingLabel || parentLabel || null;

      const wrap = document.createElement('label');
      wrap.className = 'muki-toggle';

      // input eerst, dan switch, dan tekst  → nodig voor CSS selectors
      wrap.appendChild(input);

      const sw = document.createElement('span');
      sw.className = 'muki-switch';
      wrap.appendChild(sw);

      const txt = document.createElement('span');
      txt.className = 'muki-text';
      txt.textContent = 'Alleen op voorraad'; // geforceerde tekst
      wrap.appendChild(txt);

      if (oldLabel && oldLabel !== wrap) {
        oldLabel.replaceWith(wrap);
      } else if (input.parentElement && input.parentElement !== wrap) {
        input.parentElement.insertBefore(wrap, input);
      }

      input.dataset.mukiEnhanced = "1";
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceAvailability(document);
  });

  // Drawer rendert vaak later → observeer DOM
  const mo = new MutationObserver(function (muts) {
    muts.forEach(function (mu) {
      if (mu.addedNodes && mu.addedNodes.length) {
        mu.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) enhanceAvailability(n);
        });
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Als de Filters/drawer opent, nogmaals toepassen
  document.addEventListener('click', function (e) {
    if (
      e.target &&
      (e.target.matches('[data-drawer-toggle], .facets__open-button, button[aria-controls*="Facet"]') ||
       e.target.closest('[data-drawer-toggle]'))
    ) {
      setTimeout(function () { enhanceAvailability(document); }, 250);
    }
  });
})();
